var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.total && _vm.isReady)?_c('h6',{staticClass:"secondary-title"},[_c('span',{staticClass:"text-xs-small"},[_vm._v("Results found:")]),_vm._v(" "),_c('span',{staticClass:"text-dblue"},[_vm._v(_vm._s(_vm.total))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }